import {Subsidy} from '../../../models/subsidy.model';
import {Contact} from '../../../core/services/user/contact.model';
import {FinanceDeminimi} from '../../../models/finance-deminimi.model';
import {TripleAnwer} from '../../../models/triple-answer.enum';
import {RelanceRole} from '../../../models/relance-role.model';
import {ProjectLocation} from '../../../services/project-location/project-location.model';
import {ProjectPhase} from '../../../services/project-phases/project-phase.model';

export class IvvSubsidy extends Subsidy {
	applicationContactRelanceRole?: RelanceRole;
	htmlDescriptions?: IvvDescriptions | null;
	financeDeminimis?: FinanceDeminimi[];
	projectLocations?: ProjectLocation[];
	projectPhases?: ProjectPhase[];
	projectTitle: string;
	receivedDeminimis: TripleAnwer;
	responsibleForOrganizationContact: Contact;
	applyingEstablishment: string;
	remainingFundingHow: string;

	constructor(obj: any = {}) {
		super(obj);

		this.applicationContactRelanceRole = obj.applicationContactRelanceRole;
		this.htmlDescriptions = obj.htmlDescriptions ? new IvvDescriptions(obj.htmlDescriptions) : null;
		this.financeDeminimis = obj.financeDeminimis ? obj.financeDeminimis.map((fd: any) => new FinanceDeminimi(fd)) : [];
		this.projectLocations = obj.projectLocations ? obj.projectLocations.map((pl: any) => new ProjectLocation(pl)) : [new ProjectLocation()];
		this.projectPhases = obj.projectPhases ? obj.projectPhases.map((pp: any) => new ProjectPhase(pp)).sort((p1: ProjectPhase, p2: ProjectPhase) => {
			if (p1.startDate && p2.startDate) {
				return p1.startDate.getTime() - p2.startDate.getTime();
			}

			return 0;
		}) : [new ProjectPhase()];
		this.projectTitle = obj.projectTitle;
		this.receivedDeminimis = obj.receivedDeminimis;
		this.responsibleForOrganizationContact = new Contact(obj.responsibleForOrganizationContact);
		this.subtype = obj.subtype;
		this.applyingEstablishment = obj.applyingEstablishment;
		this.remainingFundingHow = obj.remainingFundingHow;
	}
}

class IvvDescriptions {
	TARGET_AUDIENCE_AND_BARRIERS: string;
	LEARNING_AND_GROWTH_OPPORTUNITIES: string;
	NEEDS_ASSESSMENT: string;
	COOPERATION: string;
	TAILOR_MADE_HOLIDAY_PLAN: string;
	TAILOR_MADE_HOLIDAY_DESCRIPTION: string;
	HELP_TRAVELLING_INDEPENDENTLY: string;
	ESTIMATION_PARTICIPANTS_MICRO_ADVENTURE: string;
	EVALUATION_HOW: string;
	PROJECT: string;
	VISITOR_PARTICIPATION: string;

	constructor(obj: any = {}) {
		this.TARGET_AUDIENCE_AND_BARRIERS = obj.TARGET_AUDIENCE_AND_BARRIERS || '';
		this.LEARNING_AND_GROWTH_OPPORTUNITIES = obj.LEARNING_AND_GROWTH_OPPORTUNITIES || '';
		this.NEEDS_ASSESSMENT = obj.NEEDS_ASSESSMENT || '';
		this.COOPERATION = obj.COOPERATION || '';
		this.TAILOR_MADE_HOLIDAY_PLAN = obj.TAILOR_MADE_HOLIDAY_PLAN || '';
		this.TAILOR_MADE_HOLIDAY_DESCRIPTION = obj.TAILOR_MADE_HOLIDAY_DESCRIPTION || '';
		this.HELP_TRAVELLING_INDEPENDENTLY = obj.HELP_TRAVELLING_INDEPENDENTLY || '';
		this.ESTIMATION_PARTICIPANTS_MICRO_ADVENTURE = obj.ESTIMATION_PARTICIPANTS_MICRO_ADVENTURE || '';
		this.EVALUATION_HOW = obj.EVALUATION_HOW || '';
		this.PROJECT = obj.PROJECT || '';
		this.VISITOR_PARTICIPATION = obj.VISITOR_PARTICIPATION || '';
	}
}
